import { LayoutWrapper } from "@pankod/refine";
import { ReceiptList } from "modules/brands/detail/admin";
export const Receipt = () => {
    return (
        <LayoutWrapper>
            <ReceiptList />
        </LayoutWrapper>
    );
};
